import React from "react";
import IPSettingsTab from "../../../component/ip-settings/IPSettingsTab";

function IPSettings() {
  return (
    <div className="page-body">
      <IPSettingsTab />
    </div>
  );
}

export default IPSettings;
